export default "__VITE_ASSET__B3eeoY5U__"